export default __webpack_public_path__ + "static/media/blanket.e5542835.svg";